import { fetchAPI, METHODS, parseBody } from './common';
import * as Sentry from '@sentry/react';

const logErrorInSentry = ({ file, path, source, res = null, err }) => {
  Sentry.withScope((scope) => {
    scope.setContext('file_metadata', {
      source,
      size: file?.size,
      path: file?.path,
      destPath: path,
      lastModifiedDate: file.lastModifiedDate,
      lastModified: file.lastModified,
      status: res?.status,
      statusText: res?.statusText,
      fileName: file?.name,
      fileType: file?.type,
      message: err?.message,
      href: window.location?.href,
    });
    scope.captureException(new Error('Error while uploading file to s3'));
  });
};

/**
 * @typedef UploadConfig
 * @property {string} folder
 * @property {string} filetype

/**
 * Uploads an image to an S3 bucket, returns it's url.
 * @param {File} file
 * @param {string} data This is a data URI from a FileReader
 * @param {UploadConfig} config
 */
export async function upload(file, data, config, path = 'donation', source) {
  try {
    // get signed url
    const res = await fetchAPI('/image/signed-url', METHODS.post, config);
    let { url, fileName } = await parseBody(res);

    // upload image
    const blobRes = await fetch(data);
    const blobData = await blobRes.blob();
    const uploadRes = await fetch(url, { method: METHODS.put, body: blobData });
    if (uploadRes.status !== 200) {
      logErrorInSentry({ file, path, source, res: uploadRes });
    }

    return `${path}/${fileName}`;
  } catch (err) {
    logErrorInSentry({ file, path, source, err });
    throw err;
  }
}
